export const privateNotesSelector = state => state.privateNotes;
